import MainPage from "./billing.container";

export default MainPage;
